export { ColorSwatch } from './color-swatch.component';
export type { IColorSwatchProps, ColorSwatchVariant } from './color-swatch.component';
